(() => {
  const initGuide = (root) => {
    if (!root || root.dataset.guideReady === 'true') return;
    root.dataset.guideReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-guide-card]'));
    const filterButtons = Array.from(root.querySelectorAll('[data-guide-filter]'));
    const searchForm = root.querySelector('[data-guide-search-form]');
    const searchInput = root.querySelector('[data-guide-search]');
    const count = root.querySelector('[data-guide-count]');
    const empty = root.querySelector('[data-guide-empty]');
    const reset = root.querySelector('[data-guide-reset]');
    let activeFilter = 'all';

    const normalize = (value) => (value || '')
      .toLocaleLowerCase('de-DE')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const apply = () => {
      const query = normalize(searchInput?.value);
      let visible = 0;

      cards.forEach((card) => {
        const matchesFilter = activeFilter === 'all' || card.dataset.topic === activeFilter;
        const matchesSearch = !query || normalize(card.dataset.search).includes(query);
        const show = matchesFilter && matchesSearch;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (count) count.textContent = String(visible);
      if (empty) empty.hidden = visible !== 0;
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.guideFilter || 'all';
        filterButtons.forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        apply();
      });
    });

    searchForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      apply();
      root.querySelector('#alle-ratgeber')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    searchInput?.addEventListener('input', apply);

    reset?.addEventListener('click', () => {
      activeFilter = 'all';
      if (searchInput) searchInput.value = '';
      filterButtons.forEach((button) => {
        const selected = button.dataset.guideFilter === 'all';
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      apply();
      searchInput?.focus();
    });

    apply();
  };

  const initAll = () => document.querySelectorAll('[data-obp-guide]').forEach(initGuide);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
